import type { ColorsType } from "Infrastructure/Themes/Themes";

export const colors = (): ColorsType => ({
	PrimaryMain: "#D82035",
	PrimaryDark: "#D82035",
	PrimaryText: "#ffffff",
	Body: "#ffffff",
	Red: "#FF6690",
	Warning: "#F7B500",
	WarningLight: "#FACC15",
	Green: "#70f0a6",
	Text: "#233145",
	TextLight: "#64748B",
	TextDisabled: "#2f2c2766",
	Black: "#000000",
	White: "#ffffff",
	Gray: "#FAFAFA",
	Border: "#CBD5E1",
	DarkGrey: "#334155",
	Validation: "#FF6690",
	Placeholder: "#8E98A7",
	FieldBackground: "#F8FAFC",
	ContentWrapperBorder: "#E9EAEB",
	RadioBtnDisabled: "#EBEEF1",
	WorkflowIcon: "#DFE5F1",
	SuccessBg: "#13776F",
	SuccessText: "#116A62",
	WarningText: "#97761B",
	WarningBg: "#FEEEC0",
	WarningBorder: "#FEE296",
	ErrorBg: "#FFE8E8",
	ErrorBorder: "#FEC6C6",
	ErrorText: "#8A4647",
});
